import React, { createContext, useState, useEffect, useCallback, useRef } from 'react';

// Create context
export const AppContext = createContext({
  loading: false,
  error: null,
  heroDomainsList: [],
  featuredDomainsList: [],
  testinomialsList: [],
  submitForm: () => {},
  fetchDomainValuation: (domain) => {},
  domainValuation: null
});

export const AppProvider = ({ children }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [heroDomainsList, setHeroDomainsList] = useState([]);
  const [featuredDomainsList, setFeaturedDomainsList] = useState([]);
  const [testinomialsList, setTestinomialsList] = useState([]);

  const [allFaqList, setAllFaqList] = useState({});

  const [blogsList, setBlogsList] = useState([]);

  const [whoisFaqList, setWhoisFaqList] = useState([]);

  const [csrf, setCsrf] = useState('');
  const cstfToken = useRef('');

  const [domainValuation, setDomainValuation] = useState(null);


  const fetchHeroData = useCallback(async () => {
    try {
      setLoading(true);
      // const response = await getCurrentUser();
      // setUser({
      //   ...response.data,
      //   ...response.data.data.user
      // });

      try {
        const resp = await fetch(`https://api.webstadia.com/v1/dt/d3a5f3db-b852-45ac-833a-c0d684277c24`);
        const data = await resp.json();
        console.log(data);
        setHeroDomainsList(data);
      } catch (error) {

      }

      try {
        const resp2 = await fetch(`https://api.webstadia.com/v1/dt/953e35fc-7204-4e0f-8bdc-e80f8abb5cd8`);
        const data2 = await resp2.json();
        console.log(data2);
        setFeaturedDomainsList(data2);
      } catch (error) {

      }


      try {
        const resp3 = await fetch(`https://api.webstadia.com/v1/dt/6ffdda59-f038-43cf-93f7-d2715aee1b90`);
        const data3 = await resp3.json();
        console.log(data3);
        setTestinomialsList(data3);
      } catch (error) {
        console.error('Error fetching testinomials:', error);
      }

      try {
        const resp4 = await fetch(`https://api.webstadia.com/v1/fm/c6c4ee18-ce0b-4504-93be-5fb8663285c7`);
        const data4 = await resp4.json();
        console.log(data4);
        cstfToken.current = data4.token;
        setCsrf(data4.token);
      } catch (error) {
        console.error('Error fetching csrf:', error);
      }

      try {
        const resp5 = await fetch(`https://api.webstadia.com/v1/dt/6d51e3e5-1e02-4a3e-9f6b-a8187c9d1b0e`);
        const data5 = await resp5.json();
        console.log(data5);
        setBlogsList(data5);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }

      setError(null);
    } catch (error) {
      console.error('Error fetching current user:', error);
      setError('Failed to fetch user data');
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDomainValuation = useCallback(async (domain) => {
    try {
      setLoading(true);
      const resp = await fetch("https://v1.valuation.humbleworth.com/api/valuation", {
        "headers": {
          "Content-Type": "application/json"
        },
        "referrer": "https://humbleworth.com/",
        "referrerPolicy": "strict-origin-when-cross-origin",
        "body": JSON.stringify({
          domains: [domain]
        }),
        "method": "POST",
        "mode": "cors",
        "credentials": "omit"
      });
      const data = await resp.json();
      console.log(data);
      if(data && data.valuations && data.valuations.length > 0) {
        setDomainValuation(data.valuations[0]);
      }
    } catch (error) {
      console.error('Error fetching domain valuation:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchAllFaq = useCallback(async () => {
    try {
      setLoading(true);
      const resp = await fetch(`https://api.webstadia.com/v1/dt/9cf5b653-8dc7-4d70-aac9-b782e6fd662b`);
      const data = await resp.json();
      console.log(data);
      let oobj = {};
      data.forEach(element => {
        if(!oobj[element.page]) {
          oobj[element.page] = [];
        }
        oobj[element.page].push({
          q: element.question,
          a: element.answer
        });
      });
      console.log(oobj);
      setAllFaqList(oobj);
    } catch (error) {
      console.error('Error fetching all faq:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const submitForm = useCallback(async (name, email, phone, message) => {
    try {
      setLoading(true);
      const resp = await fetch(`https://api.webstadia.com/v1/fm/c6c4ee18-ce0b-4504-93be-5fb8663285c7`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          csrf: cstfToken.current,
          data: {
            name: name,
          email: email,
          phone: phone,
          message: message
          }
        })
      });
      const data = await resp.json();
      console.log(data);
      setError(null);
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Failed to submit form');
    } finally {
      setLoading(false);
    }
  }, []);

  // Effect to fetch user on mount and auth state changes
  useEffect(() => {
    fetchHeroData();
  }, [fetchHeroData]);

  useEffect(() => {
    fetchAllFaq();
  }, [fetchAllFaq]);

  // Context value
  const appContextValue = {
    loading,
    error,
    heroDomainsList,
    featuredDomainsList,
    testinomialsList,
    blogsList,
    submitForm,
    fetchDomainValuation,
    domainValuation,
    allFaqList
  };

  return (
    <AppContext.Provider value={appContextValue}>
      {children}
    </AppContext.Provider>
  );
};

export default AppProvider;